import React, { useState, useRef, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateProject } from "../../store/projectsSlice";
import "./EditProjectPosterModal.css";
import { currentOrganizationSelector } from "../../store/selectors";
import toast from "react-hot-toast";

const EditProjectPosterModal = ({
  project,
  onClose,
  onPosterUpdated,
  currentProject,
}) => {
  const dispatch = useDispatch();
  const [coverImage, setCoverImage] = useState(null);
  const [coverImageObjectUrl, setCoverImageObjectUrl] = useState(null);
  const currentOrganization = useSelector(currentOrganizationSelector);
  const [isLoading, setIsLoading] = useState(false);
  const modalRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        onClose();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [onClose]);

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (file && file.size <= 20 * 1024 * 1024) {
      setCoverImageObjectUrl(URL.createObjectURL(file));
      setCoverImage(file);
    }
  };

  const handleSubmit = () => {
    if (!coverImage) return;
    setIsLoading(true);
    let formData = new FormData();
    formData.append(
      "body",
      JSON.stringify({
        title: project.title,
        description: project.description,
        organizationId: currentOrganization.id,
      })
    );
    formData.append("file", coverImage);
    dispatch(updateProject({ id: project.id, projectData: formData })).then(
      (res) => {
        if (!res.error) {
          toast.success("Обложка сохранена");
          setIsLoading(false);
          if (onPosterUpdated) onPosterUpdated(res.payload);
          onClose();
        } else {
          setIsLoading(false);
          const errMessage =
            res.payload?.response?.data || "Неизвестная ошибка";
          toast.error(errMessage);
        }
      }
    );
  };

  return (
    <div className="edit-poster-modal-overlay">
      <div className="edit-poster-modal-editposter" ref={modalRef}>
        <button className="edit-poster-close-button" onClick={onClose} />
        <h1 className="edit-poster-modal-title">Загрузить обложку</h1>
        <div className="edit-poster-modal-content">
          <label
            className="edit-poster-upload-area"
            style={{
              border:
                coverImageObjectUrl || project?.posterUrl
                  ? "none"
                  : "2px dashed #3a3f4b",
            }}
          >
            <input
              type="file"
              accept="image/*"
              onChange={handleFileUpload}
              style={{ display: "none" }}
            />
            {coverImageObjectUrl ? (
              <img
                src={coverImageObjectUrl}
                alt="Project poster preview"
                className="edit-poster-poster-image-preview"
              />
            ) : project?.posterUrl ? (
              <>
                <img
                  src={project.posterUrl}
                  alt="Current project poster"
                  className="edit-poster-poster-image-preview"
                />
                <div
                  style={{
                    position: "absolute",
                    width: "100%",
                    height: "100%",
                    backgroundColor: " #181C24AA",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: 14,
                    fontWeight: 500,
                    fontFamily: "NT Somic",
                  }}
                >
                  <div
                    style={{
                      padding: 8,
                      paddingLeft: 16,
                      paddingRight: 16,
                      backgroundColor: "#333B4B5C",
                      border: "1px solid #F1F7FF",
                      borderRadius: 80,
                      color: "#F1F7FF",
                    }}
                  >
                    Загрузить обложку
                  </div>
                  <div
                    style={{
                      padding: 8,
                      paddingLeft: 16,
                      paddingRight: 16,
                      borderRadius: 80,
                      color: "#C1C7D4",
                    }}
                  >
                    Удалить
                  </div>
                </div>
              </>
            ) : (
              <>
                <div
                  style={{
                    position: "absolute",
                    width: "100%",
                    height: "100%",
                    backgroundColor: "transparent",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: 14,
                    fontWeight: 500,
                    fontFamily: "NT Somic",
                  }}
                >
                  <div
                    style={{
                      padding: 8,
                      paddingLeft: 16,
                      paddingRight: 16,
                      backgroundColor: "#333B4B5C",
                      border: "1px solid #F1F7FF",
                      borderRadius: 80,
                      color: "#F1F7FF",
                    }}
                  >
                    Загрузить обложку
                  </div>
                </div>
              </>
            )}
          </label>
        </div>
        <button
          onClick={handleSubmit}
          className="edit-poster-submit-button"
          disabled={isLoading || !coverImage}
        >
          {isLoading ? "Загрузка..." : "Сохранить"}
        </button>
      </div>
    </div>
  );
};

export default EditProjectPosterModal;
